import { createContext } from 'react';

// eslint-disable-next-line no-unused-vars
type ContextProps = {jwt: string, setJwt: (jwt: string) => null | void}

const AuthContext = createContext<ContextProps>({jwt: '',  setJwt: () => null});

export default AuthContext;
